import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import { motion } from 'framer-motion';
import { trackWhatsAppClick } from '../lib/analytics';

const WhatsAppButton = () => {
  const phoneNumber = '7776828551';
  const message = encodeURIComponent('Hi! I would like to book a safari tour at JMD Wildlife - Tadoba Tiger Reserve.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <motion.div
      className="fixed bottom-8 right-8 z-50"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 200, damping: 15 }}
    >
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={trackWhatsAppClick}
        data-testid="whatsapp-button"
        className="relative group block"
      >
        {/* Main Button */}
        <motion.div
          className="bg-[#25D366] hover:bg-[#128C7E] text-white rounded-2xl shadow-2xl transition-all duration-300 flex items-center gap-3 px-6 py-4"
          whileHover={{ scale: 1.05, boxShadow: '0 20px 40px rgba(37, 211, 102, 0.4)' }}
          whileTap={{ scale: 0.95 }}
          animate={{ y: [0, -8, 0] }}
          transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
        >
          {/* Icon */}
          <div className="relative">
            <MessageCircle size={32} strokeWidth={2.5} className="drop-shadow-lg" />
            <motion.div
              className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full border-2 border-white"
              animate={{ scale: [1, 1.3, 1] }}
              transition={{ repeat: Infinity, duration: 1.5 }}
            />
          </div>
          
          {/* Text */}
          <div className="hidden md:block">
            <div className="font-bold text-sm whitespace-nowrap">Book on WhatsApp</div>
            <div className="text-xs opacity-90 flex items-center gap-1">
              <Phone size={12} />
              <span>7776828551</span>
            </div>
          </div>

          {/* Pulse Ring */}
          <motion.div
            className="absolute inset-0 rounded-2xl bg-[#25D366] opacity-30"
            animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0, 0.3] }}
            transition={{ repeat: Infinity, duration: 2 }}
          />
        </motion.div>
      </a>
    </motion.div>
  );
};

export default WhatsAppButton;
